import { render, staticRenderFns } from "./CredorRemessa.vue?vue&type=template&id=2432ce0c"
import script from "./CredorRemessa.vue?vue&type=script&lang=js"
export * from "./CredorRemessa.vue?vue&type=script&lang=js"
import style0 from "./CredorRemessa.vue?vue&type=style&index=0&id=2432ce0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports